module.exports = __webpack_public_path__ + "static/media/brainsample.fa939dec.png";